<template>
    <ab-flow-base-cmp :movable="true" :block="block" class="vibrate-editor-cmp">
        <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>
        <q-card>
            <q-card-section class="bg-yellow-8 text-black">
              Vibrate: {{vibrationType}}
            </q-card-section>
        </q-card>

    </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
    components: { AbFlowBaseCmp, AbFlowLinkConnector},
    inject: ['canvas'],
    props: ['block'],
    name: "VibrateEditorCmp",
    computed: {


        /**
         * Sound channel
         * @return {{}}
         */
        vibrationType() {
            return this.block.properties?.vibrationType || "n/a"
        },
    }
}

</script>

<style lang="scss">

.vibrate-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
